import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FuseMatchMediaService {
    activeMediaQuery: string;
    onMediaChange: BehaviorSubject<string> = new BehaviorSubject<string>('');

    /**
     * Constructor
     */
    constructor() {
        // Set the defaults
        this.activeMediaQuery = '';

        // Initialize
        this._init();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Initialize
     *
     * @private
     */
    private _init(): void {
        // Simple media query detection without FlexLayout
        const checkMediaQuery = () => {
            let mqAlias = 'xs';

            if (window.matchMedia('(min-width: 1280px)').matches) {
                mqAlias = 'xl';
            } else if (window.matchMedia('(min-width: 960px)').matches) {
                mqAlias = 'lg';
            } else if (window.matchMedia('(min-width: 600px)').matches) {
                mqAlias = 'md';
            } else if (window.matchMedia('(min-width: 480px)').matches) {
                mqAlias = 'sm';
            }

            if (this.activeMediaQuery !== mqAlias) {
                this.activeMediaQuery = mqAlias;
                this.onMediaChange.next(mqAlias);
            }
        };

        // Initial check
        checkMediaQuery();

        // Listen for resize events
        window.addEventListener('resize', () => {
            setTimeout(checkMediaQuery, 100);
        });
    }
}